export async function mounted() {
  this.unitGroupID = this.$route.params.id

  console.debug('unitGroupID=' + this.unitGroupID)

  await this.getRefreshedUnitGroups()

  this.resetForm()
}
